<template>
    <el-card>
        <div class="p10">
            <el-tabs v-model="activeName">
                <template v-for="el in buttonConfig">
                    <!-- 发票登记明细查询 start -->
                    <el-tab-pane label="发票登记明细查询" name="fapiaodjmx" v-if="el.type == 'fapiaodjmx'">
                        <el-form :label-width="labelWidth">
                            <el-form-item label="指定日期">
                                <ly-date-picker width="220px" v-model="fpdjmxDateRange"></ly-date-picker>
                            </el-form-item> 
                            
                            <el-form-item label="指定业务员">
                                <ly-checkbox :data-list="yewuyuanData" :is-all="true" default-check="all" v-model="fpdjmxForm.employee_ids" style="width:700px"></ly-checkbox>
                            </el-form-item>
                            <el-form-item label="发票类型">    
                                <ly-checkbox 
                                    :data-list="fapiaoType" 
                                    :is-all="true" 
                                    default-check="all" 
                                    v-model="fpdjmxForm.invoice_type">
                                </ly-checkbox>
                            </el-form-item>
                            <el-form-item label="经营团队">
                                <ly-select width="220px" api="api/businessteam" v-model="fpdjmxForm.business_team_id"></ly-select>
                            </el-form-item>
                            <el-form-item label="指定个别客户">
                                <el-checkbox label="全部" name="type" v-model="isFpdjmxCustomer"></el-checkbox>
                                <div style="width: 842px;">
                                    <ly-product-table v-if="!isdjFpmxCustomer" :thead-config="customerConfig" ref="fpdjmxCustomer">
                                    </ly-product-table>
                                </div>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit">提交查询</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <!-- 发票登记明细查询 end -->
                    <!-- 发票明细查询 start -->
                    <el-tab-pane label="发票明细查询" name="fapiaomx" v-if="el.type == 'fapiaomx'">
                        <el-form :label-width="labelWidth">
                            <el-form-item label="指定日期">
                                <ly-date-picker width="220px" v-model="fpmxDateRange"></ly-date-picker>
                            </el-form-item>  
                            <el-form-item label="日期类型">
                                <el-radio-group v-model="fpmxForm.time_type">
                                    <el-radio label="1">开单日期</el-radio>
                                    <el-radio label="2">开票日期</el-radio>
                                </el-radio-group>
                            </el-form-item>    
                            <el-form-item label="指定业务员">
                                <ly-checkbox :data-list="yewuyuanData" :is-all="true" default-check="all" v-model="fpmxForm.employee_ids" style="width:700px"></ly-checkbox>
                            </el-form-item>
                            <el-form-item label="发票类型">    
                                <ly-checkbox 
                                    :data-list="fapiaoType" 
                                    :is-all="true" 
                                    default-check="all" 
                                    v-model="fpmxForm.invoice_type">
                                </ly-checkbox>
                            </el-form-item>
                            <el-form-item label="经营团队">
                                <ly-select width="220px" api="api/businessteam" v-model="fpmxForm.business_team_id"></ly-select>
                            </el-form-item>
                            <el-form-item label="指定个别客户">
                                <el-checkbox label="全部" name="type" v-model="isFpmxCustomer"></el-checkbox>
                                <div style="width: 842px;">
                                    <ly-product-table v-if="!isFpmxCustomer" :thead-config="customerConfig" ref="fpmxCustomer">
                                    </ly-product-table>
                                </div>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit">提交查询</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <!-- 发票明细查询 end -->
                    <!-- 发票汇总查询 start -->
                    <el-tab-pane label="发票汇总查询" name="fapiaohz" v-else-if="el.type == 'fapiaohz'">
                        <el-form :label-width="labelWidth">
                            <el-form-item label="开票日期">
                                <ly-date-picker width="220px" v-model="fphzDateRange"></ly-date-picker>
                            </el-form-item>      
                            <el-form-item label="按业务员指定客户">
                                <ly-checkbox :data-list="yewuyuanData" :is-all="true" default-check="all" v-model="fphzForm.employee_ids" style="width:700px"></ly-checkbox>
                            </el-form-item>
                            <el-form-item label="指定个别客户">
                                <el-checkbox label="全部" name="type" v-model="isFphzCustomer"></el-checkbox>
                                <div style="width: 842px;">
                                    <ly-product-table v-if="!isFphzCustomer" :thead-config="customerConfig" ref="fphzCustomer">
                                    </ly-product-table>
                                </div>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit">提交查询</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <!-- 发票汇总查询 end -->
                </template>
            </el-tabs>
        </div>
    </el-card>
</template>
<script>
    import LyDatePicker from '@c/date_picker'
    import LySelect from '@c/select'
    import LyBatch from '@c/batch'
    import LySearchForm from '@c/search-form'
    import LyProductTable from '@c/product-table'
    import LyCheckbox from '@c/checkbox'
    export default {
        components: {
            LyDatePicker,
            LySearchForm,
            LySelect, 
            LyBatch,
            LyProductTable,
            LyCheckbox
        },
        data () {
            return {
                activeName: 'fapiaomx',
                labelWidth: '120px',
                fpdjmxDateRange: '',
                fpmxDateRange:'',
                fphzDateRange: '', // 发票汇总查询的开票时间
                fapiaoType: [{id: 1, name:'增专票'},{id: 2,name: '普票'}], // 发票类型
                yewuyuanData: [], // 业务员的数据
                isFpdjmxCustomer: true,// 发票登记明细查询
                isFpmxCustomer: true, // 发票明细客户指定
                isFphzCustomer: true, // 发票明细汇总
                fpdjmxForm: { // 发票登记明细查询
                    ticket: 'fapiaodjmx',
                    date_start: '',
                    date_end: '',
                    employee_ids: [],
                    invoice_type: [],
                    business_team_id: '',
                    customer_ids: []
                },
                fpmxForm: {
                    ticket: 'fapiaomx',
                    date_start: '',
                    date_end: '',
                    time_type: '1',
                    employee_ids: [],
                    invoice_type: [],
                    business_team_id: '',
                    customer_ids: []
                },
                fphzForm: {
                    ticket: 'fapiaohz',
                    date_start: '',
                    date_end: '',
                    employee_ids: [],
                    customer_ids: []
                },
                customerConfig: [{
                    prop: 'customer',
                    label: '客户编码',
                    width: 150,
                    json: {
                        size: 'small',
                        api: 'api/customer',
                        prop: 'customer_account',
                        fields: [{
                            label: '客户编码',
                            prop: 'customer_account'
                        }, {
                            label: '客户名称',
                            prop: 'customer_name'
                        }, {
                            label: '联系人',
                            prop: 'customer_contact'
                        }, {
                            label: '联系电话',
                            prop: 'customer_tel'
                        }]
                    },
                    component: 'LyAutoSearch'
                    }, {
                        prop: 'customer',
                        label: '客户名称',
                        width: 300,
                        json: {
                            size: 'small',
                            api: 'api/customer',
                            prop: 'customer_name',
                            fields: [{
                                label: '客户编码',
                                prop: 'customer_account'
                            }, {
                                label: '客户名称',
                                prop: 'customer_name'
                            }, {
                                label: '联系人',
                                prop: 'customer_contact'
                            }, {
                                label: '联系电话',
                                prop: 'customer_tel'
                            }]
                        },
                        component: 'LyAutoSearch'
                    }, {
                        prop: 'customer',
                        label: '联系人',
                        width: 150,
                        json: {
                            size: 'small',
                            api: 'api/customer',
                            prop: 'customer_contact',
                            fields: [{
                                label: '客户编码',
                                prop: 'customer_account'
                            }, {
                                label: '客户名称',
                                prop: 'customer_name'
                            }, {
                                label: '联系人',
                                prop: 'customer_contact'
                            }, {
                                label: '联系电话',
                                prop: 'customer_tel'
                            }]
                        },
                        component: 'LyAutoSearch'
                    }, {
                    prop: 'customer',
                    label: '联系手机',
                    width: 160,
                    json: {
                        size: 'small',
                        api: 'api/customer',
                        prop: 'customer_tel',
                        fields: [{
                            label: '客户编码',
                            prop: 'customer_account'
                        }, {
                            label: '客户名称',
                            prop: 'customer_name'
                        }, {
                            label: '联系人',
                            prop: 'customer_contact'
                        }, {
                            label: '联系电话',
                            prop: 'customer_tel'
                        }]
                    },
                    component: 'LyAutoSearch'
                }],
                buttonConfig: [] // tab按钮的配置
            }
        },
        watch: {
            'fpdjmxDateRange' (v) { 
                this.fpdjmxForm.date_start = v.split("~")[0];
                this.fpdjmxForm.date_end = v.split("~")[1];
            },
            'fpmxDateRange' (v) { // 三包理赔明细查询时间段拆分赋值
                this.fpmxForm.date_start = v.split("~")[0];
                this.fpmxForm.date_end = v.split("~")[1];
            },
            'fphzDateRange' (v) {
                this.fphzForm.date_start = v.split("~")[0];
                this.fphzForm.date_end = v.split("~")[1];
            }
        },
        created () {
            this.readRouteConfig()
        },
        mounted () {
            // 初始化指定时间段，默认为当天
            let today = this.$utils.dateFormat('yyyy-MM-dd',new Date())
            this.fpdjmxDateRange = this.fphzDateRange = this.fpmxDateRange = today + "~" + today
            this.queryEmployee()
        },
        methods: {
            /**
             * 获取业务数据
             * @return {[type]} [description]
             */
            queryEmployee () {
                this.$api.query('api/employee').then((rs) => { // 正确请求成功时处理  
                    // 把获取的货品品牌的id单独出来成数组
                    rs.map((item) => {
                        this.yewuyuanData.push({
                            id: item.value,
                            name: item.label
                        })
                        this.fpmxForm.employee_ids.push(item.value)
                        this.fphzForm.employee_ids.push(item.value)
                    });
                })
            },
            onSubmit () {
                let customerIds = []; 
                let refname = ''
                if (Object.is(this.isFpdjmxCustomer, false)) {  
                    refname = 'fpdjmxCustomer'
                } else if (Object.is(this.isFpmxCustomer, false)) {  
                    refname = 'fpmxCustomer'
                } else if (Object.is(this.isFphzCustomer, false)) {
                    refname = 'fphzCustomer'
                }
                if (refname.length > 0) {
                    // 获取已选数据的id集合
                    customerIds = this.$refs[refname][0].getProductData().map((item) => {
                        return item.customer.customer_id   
                    });
                }
                // 数组去重
                customerIds = Array.from(new Set(customerIds)); 
                let data = {} // 要提交的数据
                if (this.activeName === 'fapiaodjmx') {
                    data = this.fpdjmxForm
                } else if (this.activeName === 'fapiaomx') {
                    data = this.fpmxForm
                } else if (this.activeName === 'fapiaohz') {
                    data = this.fphzForm
                }
                data.customer_ids = customerIds // 获取客户列表
                // 调用接口
                this.$api.export.create(data).then((rs) => { // 正确请求成功时处理  
                    this.$alert('查询任务已提交，请前往查询下载中心下载计算完毕的数据', '提示信息', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'success',
                        showCancelButton: true
                    }).then(() => {
                        this.$router.push({name: 'download'})
                    }, () => {})
                }).catch((error) => { // 捕捉错误处理  
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            /**
             * 读取当前页面的路有配置
             */
            readRouteConfig () {
                // 获得当前页面的配置
                let routeConfig = this.$utils.readRouteConfig(this.$route.fullPath)
                // 获得tab的配置
                if (routeConfig && routeConfig.page && routeConfig.page.length > 0) {
                    let config = routeConfig.page[0]['config']
                    if (typeof config.buttons === 'string') {
                        config.buttons = JSON.parse(config.buttons)
                    }
                    this.buttonConfig = config.buttons || []
                    // 设置默认的activeName 
                    if (this.buttonConfig.length > 0) {
                        this.activeName = this.buttonConfig[0]['type']
                    }
                }
            }
        }
    }
</script>